import "./sw-code.module.css";
import { html } from "lit-html";
import { LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

export default (user) => html`
    <div
        id="sw-code"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-70 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-gray-200 rounded-lg shadow-sm dark:bg-gray-500">
                <!-- Modal header -->
                <div class="flex items-start justify-between p-4 md:p-5">
                    <picture
                        onclick="heartbank.alertAdmin('qrcode/click/qr-code')"
                        class="relative ml-[-10%] mb-[-19%] mt-[3%] inline-block w-full">
                        <svg
                            class="block fill-hb"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24">
                            <path
                                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                transform="rotate(45 12 12)" />
                        </svg>
                        <img
                            id="sw-code-qr"
                            alt="qr code"
                            class="absolute w-[43%] ml-[-3%] mt-[3%] top-1/2 left-1/2 -rotate-90 transform -translate-x-1/2 -translate-y-1/2" />
                    </picture>
                    <button
                        title="${Strings.close[LANGUAGE]}"
                        type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="sw-code">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">${Strings.close[LANGUAGE]}</span>
                    </button>
                </div>
                <!-- Modal body -->
                <!-- Modal footer -->
                <div class="items-center justify-around p-4 md:p-5">
                    <button
                        id="sw-code-button"
                        onclick="heartbank.alertAdmin('qrcode/click/copy')"
                        type="button"
                        class="w-full text-white bg-theme hover:bg-theme focus:ring-4 focus:outline-none focus:ring-theme font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme dark:focus:ring-theme">
                        ${Strings.code2[LANGUAGE]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
